class InitialServices {
  populateTiles() {
    return new Promise(resolve => {
      let initData = [
        {
          location: "life-one",
          title: "Ubezpieczenie życia",
          description:
            "Do 500.000&nbsp;zł w&nbsp;razie śmierci wskutek wypadku",
          category: "life",
          page: 2,
          videoId: "1"
        },
        {
          location: "life-two",
          title: "Ubezpieczenie życia",
          description:
            "Do 10.000.000&nbsp;zł w&nbsp;razie śmierci z&nbsp;każdej przyczyny jako&nbsp;zabezpieczenie kredytu",
          category: "life",
          page: 3,
          videoId: "2"
        },
        {
          location: "life-three",
          title: "Ubezpieczenie życia",
          description:
            "Do 10.000.000&nbsp;zł w&nbsp;razie śmierci z&nbsp;każdej przyczyny",
          category: "life",
          page: 4,
          videoId: "3"
        },
        {
          location: "body-one",
          title: "Uszkodzenie ciała",
          description:
            "Do 500.000&nbsp;zł w&nbsp;razie poważnego inwalidztwa lub&nbsp;złamań wskutek wypadku",
          category: "body",
          page: 5,
          videoId: "4"
        },
        {
          location: "body-two",
          title: "Niezdolność do pracy",
          description:
            "Do 1.000.000&nbsp;zł w&nbsp;razie niezdolności do&nbsp;pracy wskutek wypadku jako&nbsp;zabezpieczenie kredytu",
          category: "body",
          page: 6,
          videoId: "5"
        },
        {
          location: "body-three",
          title: "Niezdolność do pracy",
          description:
            "Do 4.000.000&nbsp;zł wypłacanych w&nbsp;formie miesięcznej renty w&nbsp;razie niezdolności do&nbsp;pracy z&nbsp;każdej przyczyny",
          category: "body",
          page: 7,
          videoId: "6"
        },
        {
          location: "sick-one",
          title: "Poważne zachorowanie",
          description: "Do 200.000&nbsp;zł w&nbsp;razie wystąpienia nowotworu",
          category: "sick",
          page: 8,
          videoId: "7"
        },
        {
          location: "sick-two",
          title: "Poważne zachorowanie",
          description:
            "Do 200.000&nbsp;zł w&nbsp;razie wystąpienia nowotworu lub&nbsp;jednej&nbsp;z&nbsp;11 innych chorób",
          category: "sick",
          page: 9,
          videoId: "8"
        },
        {
          location: "sick-three",
          title: "Poważne zachorowanie",
          description:
            "Do 200.000&nbsp;zł w&nbsp;razie wystąpienia nowotworu lub&nbsp;jednej&nbsp;z&nbsp;49 innych chorób",
          category: "sick",
          page: 10,
          videoId: "9"
        },
        {
          location: "child-one",
          title: "Zdrowie dziecka",
          description:
            "Do 200.000&nbsp;zł w razie poważnego inwalidztwa lub&nbsp;złamań wskutek wypadku",
          category: "child",
          page: 11,
          videoId: "a"
        },
        {
          location: "child-two",
          title: "Zdrowie dziecka",
          description:
            "Do 200.000&nbsp;zł w&nbsp;razie wystąpienia nowotworu lub&nbsp;jednej&nbsp;z&nbsp;19 innych chorób",
          category: "child",
          page: 12,
          videoId: "b"
        },
        {
          location: "child-three",
          title: "Zdrowie dziecka",
          description:
            "Do 200.000&nbsp;zł w&nbsp;razie poważnego inwalidztwa, złamań wskutek wypadku lub&nbsp;wystąpienia jednej&nbsp;z&nbsp;20&nbsp;chorób",
          category: "child",
          page: 13,
          videoId: "c"
        },
        {
          location: "best-doctors-one",
          title: "Global Doctors",
          description:
            "Do 1.000.000&nbsp;euro na&nbsp;organizację i&nbsp;pokrycie kosztów leczenia nowotworów",
          category: "doctors",
          page: 14,
          videoId: "d"
        },
        {
          location: "best-doctors-two",
          title: "Global Doctors",
          description:
            "Do 2.000.000&nbsp;euro na&nbsp;organizację i&nbsp;pokrycie kosztów leczenia nowotworów i&nbsp;wybranych stanów chorobowych",
          category: "doctors",
          page: 15,
          videoId: "e"
        },
        {
          location: "best-doctors-three",
          title: "",
          description: "",
          category: "doctors",
          page: 16,
          videoId: "f"
        }
      ];
      resolve(initData);
    });
  }

  populateStars() {
    return new Promise(resolve => {
      resolve(["star-one", "star-two", "star-three"]);
    });
  }

  getVideoList() {
    let videoList = [
      {
        id: "1",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/9ef3d624-9608-4a69-8d74-f0478dce701b/01_ubez_zycia_nw.ism/manifest(format=m3u8-aapl)",
        name: "01_ubez_zycia_nw"
      },
      {
        id: "2",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/6344851e-95aa-4700-bf6c-e6c2962fc6e8/02_ubez_zycia_kredyt_1920x1080_6.ism/manifest(format=m3u8-aapl)",
        name: "02_ubez_zycia_kredyt"
      },
      {
        id: "3",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/6ebb1fbe-e25d-4b5f-adf7-c122f65fa980/03_ubez_zycia_pelny.ism/manifest(format=m3u8-aapl)",
        name: "03_ubez_zycia_pelny"
      },
      {
        id: "4",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/7502bb78-bf2b-4abe-ae9e-1d4ebd211d72/04_uszkodzenie_ciala_NW.ism/manifest(format=m3u8-aapl)",
        name: "04_uszkodzenie_ciala_NW"
      },
      {
        id: "5",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/ebcb9e8d-0fcc-475c-90aa-ec7bef0be7ce/05_niezdolnosc_pracy_kredyt.ism/manifest(format=m3u8-aapl)",
        name: "05_niezdolnosc_pracy_kredyt"
      },
      {
        id: "6",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/b01afa79-a178-4427-ab8e-d4cadba44b38/06_niezdolnosc_pracy_pelny.ism/manifest(format=m3u8-aapl)",
        name: "06_niezdolnosc_pracy_pelny"
      },
      {
        id: "7",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/33b279b4-919f-413d-8a08-0cb502dc5dbc/07_powazne_zachorowanie_nowotwor.ism/manifest(format=m3u8-aapl)",
        name: "07_powazne_zachorowanie_nowotwor"
      },
      {
        id: "8",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/99cfd155-075d-4c70-a116-32eb5f70d90c/08_powazne_zachorowanie_rozszerz.ism/manifest(format=m3u8-aapl)",
        name: "08_powazne_zachorowanie_rozszerz"
      },
      {
        id: "9",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/cf7d4c79-1e5b-4cba-b94b-d3deb3e89520/09_powazne_zachorowanie_pelny.ism/manifest(format=m3u8-aapl)",
        name: "09_powazne_zachorowanie_pelny"
      },
      {
        id: "a",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/8e1062ef-82e8-4ea0-abd4-ddf131fa992a/10_dziecko_szkodzenie_ciala_NW.ism/manifest(format=m3u8-aapl)",
        name: "10_dziecko_szkodzenie_ciala_NW"
      },
      {
        id: "b",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/3829038e-1c61-45fa-9295-b2576b7d70b9/11_dziecko_powazne_zachorowanie.ism/manifest(format=m3u8-aapl)",
        name: "11_dziecko_powazne_zachorowanie"
      },
      {
        id: "c",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/561fd826-5817-4dff-9ae9-a23ae14259a0/12_dziecko_pelny.ism/manifest(format=m3u8-aapl)",
        name: "12_dziecko_pelny"
      },
      {
        id: "d",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/243475dc-43bf-4017-9a5a-df0add19557c/13_Global_Doctors_podst.ism/manifest(format=m3u8-aapl)",
        name: "13_Global_Doctors_podst"
      },
      {
        id: "e",
        src:
          "https://ofertomatvideo-euno.streaming.media.azure.net/81fc7f62-7c86-4867-845a-3dba8e0375a8/14_Global_Doctors_rozszerzony.ism/manifest(format=m3u8-aapl)",
        name: "14_Global_Doctors_rozszerzony"
      }
    ];
    return videoList;
  }
}

export default new InitialServices();
